import { smb_fetch, getAgsApiUrl } from '../../../fetch';

export const getPromotedObject = (data = {}) => {
  const url = getAgsApiUrl('promoted-object');
  return smb_fetch(url, {
    method: 'GET',
    isCache: true,
    data,
  }, false, false);
};

export const getSourceType = (data = {}) => {
  const url = getAgsApiUrl('source-type');
  return smb_fetch(url, {
    method: 'GET',
    isCache: true,
    data,
  }, false, false);
};

export const getSourceTypeTag = (data = {}) => {
  const url = getAgsApiUrl('source-type-tag');
  return smb_fetch(url, {
    method: 'GET',
    isCache: true,
    data,
  }, false, false);
};

export const getAgencyList = (data = {}) => {
  const url = getAgsApiUrl('agency', 'list');
  return smb_fetch(url, {
    method: 'GET',
    isCache: true,
    data,
  }, false, false);
};

/**
 * 获取区域列表
 * @return
 */
export const getAreaCodeList = (data, isCache = true) => {
  const url = getAgsApiUrl('area');
  return smb_fetch(url, {
    method: 'GET',
    isCache,
    data,
  }, false, false);
};

/**
 * 获取行业列表
 * @return
 */
export const getIndustryList = (data, isCache = true) => {
  const url = getAgsApiUrl('industry');
  return smb_fetch(url, {
    method: 'GET',
    isCache,
    data,
  }, false, false);
};
